module.exports = __webpack_public_path__ + "img/Search.0a12d69d.svg";